import BlogDetailsSection3 from './BlogDetailsSection3' ;
import BlogDetailsBanner3 from './BlogDetailsBanner3' ;

function BlogDetails3() {
  return (
    <div>
      <BlogDetailsBanner3 />
      <BlogDetailsSection3 />
    </div>
  );
}

export default BlogDetails3;